import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, } from '@angular/core';
import * as i0 from "@angular/core";
const _c0 = ["mheCollapseTray", ""];
const _c1 = ["*"];
export class CollapseTrayComponent {
    constructor(hostElement) {
        this.hostElement = hostElement;
        this.collapse = new EventEmitter();
        this.expand = new EventEmitter();
        this.expandedDisplayStyle = 'block';
    }
    set mheCollapseTray(value) {
        this.displayTray(value);
    }
    ngOnInit() {
        // Determine inital computed display style for host element to use for expanded view.
        // If initially hidden, default display is block.
        const computedDisplayStyle = getComputedStyle(this.hostElement.nativeElement).display;
        if (computedDisplayStyle && computedDisplayStyle !== 'none') {
            this.expandedDisplayStyle = computedDisplayStyle;
            this.displayTray(this.collapseHidden, false);
        }
    }
    displayTray(collapsed, emitEvents = true) {
        if (collapsed === true || collapsed === undefined) {
            this.collapseContainer(emitEvents);
        }
        else {
            this.expandContainer(emitEvents);
        }
    }
    collapseContainer(emitEvents) {
        this.display = 'none';
        this.collapseHidden = true;
        if (emitEvents) {
            this.collapse.emit(this);
        }
    }
    expandContainer(emitEvents) {
        this.display = this.expandedDisplayStyle;
        this.collapseHidden = false;
        if (emitEvents) {
            this.expand.emit(this);
        }
    }
}
CollapseTrayComponent.ɵfac = function CollapseTrayComponent_Factory(t) { return new (t || CollapseTrayComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
CollapseTrayComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CollapseTrayComponent, selectors: [["", "mheCollapseTray", ""]], hostVars: 4, hostBindings: function CollapseTrayComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵstyleProp("display", ctx.display);
        i0.ɵɵclassProp("collapse-hidden", ctx.collapseHidden);
    } }, inputs: { mheCollapseTray: "mheCollapseTray" }, outputs: { collapse: "collapse", expand: "expand" }, exportAs: ["mhe-collapse-tray"], attrs: _c0, ngContentSelectors: _c1, decls: 1, vars: 0, template: function CollapseTrayComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: [".collapse-hidden[_nghost-%COMP%]     *{display:none !important}\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapseTrayComponent, [{
        type: Component,
        args: [{ selector: '[mheCollapseTray]', exportAs: 'mhe-collapse-tray', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n", styles: [":host(.collapse-hidden) ::ng-deep *{display:none !important}/*# sourceMappingURL=collapse-tray.component.css.map */\n"] }]
    }], function () { return [{ type: i0.ElementRef }]; }, { mheCollapseTray: [{
            type: Input
        }], collapse: [{
            type: Output
        }], expand: [{
            type: Output
        }], display: [{
            type: HostBinding,
            args: ['style.display']
        }], collapseHidden: [{
            type: HostBinding,
            args: ['class.collapse-hidden']
        }] }); })();
